const POPOVER_VISIBLE_MS = 10000;
let popoverHideTimeout;

const setPopoverActionVisible = (popover, actionEl, visible) => {
  if (!actionEl) return;
  popover?.classList.toggle('has-action', visible);
  if (visible) {
    actionEl.removeAttribute('hidden');
  } else {
    actionEl.setAttribute('hidden', '');
  }
};

const showNotification = (type, message, options = {}) => {
  const popover = document.querySelector('.atom-popover-notification');
  if (!popover) return;

  const popoverIconSuccess = popover.querySelector('.atom-popover-notification__icon-success');
  const popoverIconError = popover.querySelector('.atom-popover-notification__icon-error');
  const popoverMessage = popover.querySelector('.atom-popover-notification__message');
  const popoverAction = popover.querySelector('.atom-popover-notification__action');
  const isSuccess = type === 'success';
  const showAction = isSuccess && options.showCartLink && popoverAction;

  if (popoverHideTimeout) clearTimeout(popoverHideTimeout);

  popoverIconSuccess?.classList.remove('is-visible');
  popoverIconError?.classList.remove('is-visible');

  (isSuccess ? popoverIconSuccess : popoverIconError)?.classList.add('is-visible');
  if (popoverMessage) popoverMessage.textContent = message;
  setPopoverActionVisible(popover, popoverAction, showAction);
  popover.classList.remove('is-type-success', 'is-type-error');
  popover.classList.add('is-visible', isSuccess ? 'is-type-success' : 'is-type-error');

  popoverHideTimeout = setTimeout(() => {
    popover.classList.remove('is-visible', 'is-type-success', 'is-type-error', 'has-action');
    popoverIconSuccess?.classList.remove('is-visible');
    popoverIconError?.classList.remove('is-visible');
    setPopoverActionVisible(popover, popoverAction, false);
    popoverHideTimeout = null;
  }, POPOVER_VISIBLE_MS);
};

const syncCartStateAfterAdd = (variantId) =>
  fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
    .then((res) => res.json())
    .then((cartData) => {
      updateHeaderCartCount(cartData.item_count);
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: variantId,
        cartData,
      });
    });

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.stayOnPage = this.dataset.stayOnPage === 'true';

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && !this.stayOnPage) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;
            const variantId = formData.get('id');

            if (this.stayOnPage) {
              showNotification('success', window.cartStrings.itemAdded, { showCartLink: true });
              return syncCartStateAfterAdd(variantId);
            }

            if (!this.cart) {
              const domain = window.location.hostname.replace('shop.', '');
              document.cookie = `cartItems=${response.quantity}; domain=.${domain}; max-age=${60 * 60 * 24 * 7}; path=/`;
              window.location = window.routes.cart_url;
              return;
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            return syncCartStateAfterAdd(variantId);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        if (!errorMessage) return;
        showNotification('error', errorMessage);
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
